import { IEmailProvider, EmailData, EmailResponse } from '../types';

/**
 * FormSpree Provider - Servicio gratuito sin backend
 * Requiere: Cuenta en https://formspree.io
 * Gratis: 50 emails/mes
 */
export class FormSpreeProvider implements IEmailProvider {
  private formId: string;

  constructor() {
    this.formId = process.env.REACT_APP_FORMSPREE_ID || '';
  }

  async initialize(): Promise<void> {
    if (!this.formId) {
      throw new Error('FormSpree Form ID not configured');
    }
  }

  async sendEmail(data: EmailData): Promise<EmailResponse> {
    try {
      const formData: any = {
        name: data.name,
        email: data.email,
        message: data.message,
        _subject: data.subject || `Nuevo mensaje de ${data.name} - Portfolio`,
      };

      // FormSpree soporta reCAPTCHA cuando lo habilitas en su dashboard
      if (data.recaptchaToken) {
        formData['g-recaptcha-response'] = data.recaptchaToken;
      }

      const response = await fetch(`https://formspree.io/f/${this.formId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        return {
          success: true,
          message: 'Email sent successfully via FormSpree',
        };
      }

      throw new Error('Failed to send email');
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to send email via FormSpree',
      };
    }
  }
}
